import { createModule, mutation } from 'vuex-class-component';
import { HeaderModel } from '../models/headerModel';

const VuexModule = createModule({
  namespaced: 'Header',
  strict: false,
  target: 'nuxt',
});

export default class HeaderStore extends VuexModule {
  specialty = 'JavaScript';
  headerModel: HeaderModel = {} as HeaderModel;

  @mutation setHeaderData(header: HeaderModel) {
    this.headerModel = header;
  }

  get getHeaderData() {
    return this.headerModel;
  }
}
